// extracted by mini-css-extract-plugin
module.exports = {"container":"ticker_container__Wa0Re","messages":"ticker_messages__HWTiY","message":"ticker_message__prKC5"};